import React from 'react';
import styled from 'styled-components';
import { Card } from 'styleguide/Card';
import { TextLG, TextSMRegular } from 'styleguide/Texts';
import { View } from 'styleguide/View';
import { ProfileImage } from 'components/ProfileImage';
import { FollowButtonPrimary } from 'components/FollowButton';
import { Link } from 'components/Link';
import { ProfileStat } from 'components/ProfileStat';
import { Spacing } from 'styleguide/spacing';

const Container = styled(Card)`
  display: flex;
  padding: ${Spacing.md}px;
`;

const UpperContainer = styled.div`
  display: flex;
  gap: ${Spacing.md}px;
`;

const StatsContainer = styled.div`
  display: flex;
  margin-top: ${Spacing.sm}px;
  gap: ${Spacing.md}px;
`;

const LowerContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${Spacing.md}px;
`;

interface UserCardProps {
  profileImage?: string;
  username: string;
  description?: string;
  workoutCount: string;
  followerCount: string;
  followingCount: string;
  showFollowButton: boolean;
}

export const UserCard = ({
  profileImage,
  username,
  description,
  workoutCount,
  followerCount,
  followingCount,
  showFollowButton,
}: UserCardProps) => {
  return (
    <Container>
      <Link href={`/user/${username}`}>
        <UpperContainer>
          <ProfileImage diameter={75} source={profileImage} />
          <View>
            <TextLG>{username}</TextLG>
            <StatsContainer>
              <ProfileStat label="Workouts" count={workoutCount} />
              <ProfileStat label="Followers" count={followerCount} />
              <ProfileStat label="Following" count={followingCount} />
            </StatsContainer>
          </View>
        </UpperContainer>
      </Link>
      {(!!description || showFollowButton) && (
        <LowerContainer>
          {!!description && (
            <TextSMRegular type="secondary" style={{ whiteSpace: 'pre-wrap' }}>
              {description}
            </TextSMRegular>
          )}
          {showFollowButton && (
            <View style={{ marginTop: Spacing.md }}>
              <FollowButtonPrimary
                style={{ width: '100%' }}
                buttonStyle={{ width: '100%' }}
                username={username}
              />
            </View>
          )}
        </LowerContainer>
      )}
    </Container>
  );
};
